import {
  ADD_PAGE,
  ADD_TILES,
  ADD_FLAG_IS_APP_VIEW,
  ADD_FLAG_VISITED_RENEWAL_PAGE,
  ADD_FLAG_EXIT_PAGE_POPUP_DISPLAYED,
  TOGGLE_BATTERY_REPLACE_REMOVED_POPUP,
  SET_REFRESH_VEHICLES_LIST,
  DOWNGRADE_POPUP_STATUS,
} from 'constants/contentConstants';

const content = (
  // eslint-disable-next-line default-param-last
  state = {
    pages: [],
    tiles: {},
    flags: {
      isAppView: false,
      visitedRenewalPage: false,
      exitPagePopupDisplayed: false,
      batteryReplaceRemovedPopup: DOWNGRADE_POPUP_STATUS.NOT_DISPLAYED,
      refreshVehiclesList: false,
    },
  },
  action,
) => {
  const findPageByUid = () => {
    // Get all uid values in state.pages array
    const uidArray = state.pages.map((page) => {
      if (page && page.uid) {
        return page.uid;
      }
      return null;
    });
    // Check if action value already exists to avoid duplicates being added
    const match = uidArray.includes(action.id);
    return match;
  };
  switch (action.type) {
    case ADD_PAGE:
      // eslint-disable-next-line no-case-declarations
      const isPageAlreadyAdded = findPageByUid();
      if (!state.pages.length || !isPageAlreadyAdded) {
        // Push page object to state pages array on initial population or when new content found where uid does not already exist in store
        return {
          ...state,
          pages: [...state.pages, action.page],
        };
      }
      return state;
    case ADD_TILES:
      return {
        ...state,
        tiles: { ...state.tiles, [action.tileSet]: [...action.payload] },
      };
    case ADD_FLAG_IS_APP_VIEW:
      return {
        ...state,
        flags: {
          ...state.flags,
          isAppView: action.payload,
        },
      };
    case ADD_FLAG_VISITED_RENEWAL_PAGE:
      return {
        ...state,
        flags: {
          ...state.flags,
          visitedRenewalPage: action.payload,
        },
      };
    case ADD_FLAG_EXIT_PAGE_POPUP_DISPLAYED:
      return {
        ...state,
        flags: {
          ...state.flags,
          exitPagePopupDisplayed: action.payload,
        },
      };
    case TOGGLE_BATTERY_REPLACE_REMOVED_POPUP:
      return {
        ...state,
        flags: {
          ...state.flags,
          batteryReplaceRemovedPopup: action.payload,
        },
      };
    case SET_REFRESH_VEHICLES_LIST:
      return {
        ...state,
        flags: {
          ...state.flags,
          refreshVehiclesList: action.payload,
        },
      };
    default:
      return state;
  }
};

export default content;
